import { render, staticRenderFns } from "./previewSumIcon.vue?vue&type=template&id=45fad05b&"
import script from "./previewSumIcon.vue?vue&type=script&lang=js&"
export * from "./previewSumIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports